import Vue from 'vue'
import VueRouter from 'vue-router'
import myMixin from './mixin'
import myParate from './parate'
import { Message } from 'element-ui'
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Index',
		component: () => import('@/views/OutIndex/index.vue'),
		redirect: '/Home',
		children: [
			...myMixin,
			...myParate,
			{	
				path: '/Home',
				name: 'Home',
				component: () => import('@/views/Home/index.vue')
			},
			{
				path: '/Sigin',
				name: 'Sigin',
				component: () => import('@/views/Sigin/index.vue')
			},
			{
				path: '/AddDesktop',
				name: 'AddDesktop',
				component: () => import('@/views/AddDesktop/index.vue')
			},
			// { 
			// 	path: '/Roll',
			// 	name: 'Roll',
			// 	component: () => import('@/views/Roll/index.vue')
			// },

			// {
			// 	path: '/Lucky',
			// 	name: 'Lucky',
			// 	component: () => import('@/views/Lucky/index.vue')
			// },

			// {
			// 	path: '/Shop',
			// 	name: 'Shop',
			// 	component: () => import('@/views/Shop/index.vue')
			// },

			// {
			// 	path: '/Cooperation',
			// 	name: 'Cooperation',
			// 	component: () => import('@/views/Cooperation/index.vue')
			// },

			// {
			// 	path: '/BoxFight',
			// 	name: 'BoxFight',
			// 	component: () => import('@/views/BoxFight/index.vue')
			// },
            // {
			// 	path: '/BattlePage',
			// 	name: 'BattlePage',
			// 	component: () => import('@/views/BattlePage/index.vue')
			// },
			// {
			// 	path: '/Activity',
			// 	name: 'Activity',
			// 	component: () => import('@/views/Activity/index.vue')
			// },
			// {
			// 	path: '/Activity_open',
			// 	name: 'Activity_open',
			// 	component: () => import('@/views/Activity/Activity_open.vue')
			// },
			// {
			// 	path: '/Replacement',
			// 	name: 'Replacement',
			// 	component: () => import('@/views/Replacement/index.vue')
			// },
			// {
			// 	path: '/OpeningBox',
			// 	name: 'OpeningBox',
			// 	component: () => import('@/views/OpeningBox/index.vue')
			// },
			// {
			// 	path: '/Vip',
			// 	name: 'Vip',
			// 	component: () => import('@/views/Vip/index.vue')
			// },
			// {
			// 	path: '/Sigin',
			// 	name: 'Sigin',
			// 	component: () => import('@/views/Sigin/index.vue')
			// },

		]
	},
	// {
	//     path: '/NotOpen',
	//     name: 'NotOpen',
	//     component: () => import('@/views/NotOpen/index.vue')
	// },
	// {
	// 	path: '/Payment',
	// 	name: 'Payment',
	// 	component: () => import('@/views/Payment/index.vue')
	// }

]

const router = new VueRouter({
	//mode: 'history',
	routes
})


router.beforeEach((to, from, next) => {
  if (to.path === '/Warehouse' || to.path === '/about' || to.path === '/Extension' || to.path === '/Recharge' || to.path === '/CreatingRooms' || to.path === '/WelfareInfo') {
    let token = sessionStorage.getItem('token')
	if (token === null || token === '') {
	  //next('/Home')
	  Message({
	    message:"您还未登陆，请先登陆!",
	    type:'error'
	  })
	} else {
	  next();
	}
  } else {
	 next();
  }
})

export default router
